import React, { useEffect } from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { inits } from 'app-redux/actions'
import { loadedInitSelector, loginFormSelector, userSelector } from 'app-redux/selectors'
import LoginModal from 'pages/user/login/LoginModal'
import { isTokenExist } from '@/utils/cookies'

/**
 * Layout layar pelanggan: tanpa menu, shift, kunci layar, atau listener Pusher milik kasir,
 * supaya perangkat layar hanya membuka satu koneksi realtime.
 * Access token yang expired di-refresh otomatis (utils/axios + utils/pusher). Modal login hanya
 * muncul bila sesi benar-benar berakhir (refresh token tidak valid / logout), supaya layar tidak
 * mati diam-diam; setelah login ulang, layar lanjut di halaman yang sama.
 */
const CustomerDisplayLayout = ({ children }) => {
  const dispatch = useDispatch()
  const loadedInit = useSelector(loadedInitSelector)
  const { id: userId } = useSelector(userSelector)
  const { showLoginForm } = useSelector(loginFormSelector)

  useEffect(() => {
    if (!userId && !loadedInit) {
      dispatch(inits())
    }
  }, [userId, loadedInit, dispatch])

  // Sesi berakhir saat layar sudah tampil → login lewat modal, tetap di halaman ini
  if (!isTokenExist() && !showLoginForm) {
    return <Redirect to="/user/login" />
  }

  if (!loadedInit) {
    return (
      <div style={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spin indicator={<LoadingOutlined spin />} size="large" />
      </div>
    )
  }

  return (
    <>
      {children}
      {showLoginForm && <LoginModal />}
    </>
  )
}

export default CustomerDisplayLayout
